"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = __importStar(require("react"));
const react_helmet_1 = require("react-helmet");
const useCookiesConsent_1 = require("../hooks/useCookiesConsent");
const cookieConsentPreferences_1 = require("../models/cookieConsentPreferences");
const useService_1 = require("../hooks/useService");
function GoogleTagManager(props) {
    const { containerId } = props;
    const { defaultConsentIsSet, setDefaultConsentIsSet } = (0, useCookiesConsent_1.useCookiesConsent)();
    const cookieService = (0, useService_1.useService)("CookieService");
    const gtmCookieConsentService = (0, useService_1.useService)("GtmCookieConsentService");
    (0, react_1.useEffect)(() => {
        if (!defaultConsentIsSet) {
            gtmCookieConsentService.setContainerId(containerId);
            const savedCookieConsent = cookieService.getCookieConsentPreferences();
            if (savedCookieConsent) {
                gtmCookieConsentService.setConsent(savedCookieConsent, true);
            }
            else {
                gtmCookieConsentService.setConsent(cookieConsentPreferences_1.DEFAULT_COOKIE_CONSENT_PREFERENCES, true);
            }
            setDefaultConsentIsSet(true);
        }
    }, []);
    return defaultConsentIsSet ? (react_1.default.createElement(react_helmet_1.Helmet, null,
        react_1.default.createElement("script", { type: "text/javascript" }, `
            (function(w,d,s,l,i){
              w[l]=w[l]||[];
              w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
              var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
              j.async=true;
              j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
              f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${containerId}');
            `))) : (react_1.default.createElement(react_1.default.Fragment, null));
}
exports.default = GoogleTagManager;
//# sourceMappingURL=GoogleTagManager.js.map